import { useRouter } from 'next/router';
import { FC } from 'react';
import { IoStarSharp } from 'react-icons/io5';

import { Button, ButtonProps } from '@mantine/core';

import { ProjectHelpers } from 'helpers/ProjectHelpers';

const SubscriptionOnboardingButton: FC<ButtonProps & { onClick?: () => void }> = ({
    children = 'Upgrade',
    onClick,
    ...props
}) => {
    const router = useRouter();

    return (
        <Button
            onClick={() => {
                onClick?.();
                router.push(`${ProjectHelpers.urls.upgrade()}?redirect=${router.asPath}`).then();
            }}
            leftSection={<IoStarSharp size={16} />}
            {...props}
        >
            {children}
        </Button>
    );
};

export { SubscriptionOnboardingButton };
